import {Button, Spinner} from '@sail/ui';
import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: 'conversations_ui.widget.requestACallTopBar.cancel',
    description: 'Button to cancel the request a call',
    defaultMessage: 'Cancel',
  },
  calling: {
    id: 'conversations_ui.widget.requestACallTopBar.calling',
    description: 'Button text when a call is in progress',
    defaultMessage: 'Calling',
  },
});

export const CancelButton = ({
  isLoading,
  isCalling,
  onCancel,
}: {
  isLoading: boolean;
  isCalling: boolean;
  onCancel: () => void;
}) => {
  return (
    <Button
      data-testid="cancel-rac-button"
      size="small"
      css={{marginLeft: 'small'}}
      onPress={onCancel}
      disabled={isCalling || isLoading}
    >
      {isLoading ? (
        <Spinner
          data-testid="loading-spinner"
          css={{
            width: 'fill',
            paddingX: 'small',
          }}
        />
      ) : (
        <FormattedMessage
          {...(isCalling ? messages.calling : messages.cancel)}
        />
      )}
    </Button>
  );
};
